<template>
        <section class="section-padding mx-sm-4 mx-1" style="border-radius: 16px">
      <v-container class="px-md-10 px-5 mx-auto" style="max-width: 1440px">
        <h2
          class="alt-h2 gradient-text-green-blue font-weight-black mb-12 text-center"
        >
          FAQ
        </h2>

        <v-row style="justify-content: center">
          <v-col
            cols="12"
            sm="6"
            md="5"
            class="d-flex mt-15"
            v-for="q in faq"
            :key="q.question"
          >
            <div class="img mr-3">
              <v-icon color="#00a3e9" size="35" style="vertical-align: top">
                {{ icons.mdiCommentQuestion }}
              </v-icon>
            </div>
            <div>
              <h3 class="text-h6">{{ q.question }}</h3>
              <p class="color-muted mb-1 col-md-10 pa-0" v-html="q.answer"></p>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
</template>
<script>
import { mdiCommentQuestion } from '@mdi/js'
export default {
  props: {
    is_quote: {
      type: [Boolean],
      required: false,
      default: false
    },
    faq: {
      type: [Array],
      required: true,
      default: function () {
        return []
      },
    },
  },
  data: () => ({
    icons: {
      mdiCommentQuestion,
    },
  }),
  mounted() {
    if (this.is_quote) {
      this.faq.splice(4, 1);
      this.faq.splice(10, 1);
    } else {
      this.faq.splice(0, 1);
      this.faq.splice(0, 1);
    }
  }
}
</script>